import { useEffect, useState } from 'react';
import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { getTournamentPlayers } from '../../../services/tournament.service';

const getPodiumColor = (idx) => {
  if (idx === 0) return '#fbbf24';
  if (idx === 1) return '#cbd5e1';
  if (idx === 2) return '#d97706';
  return '#94a3b8';
};

const headerSx = {
  py: 0.75,
  background: '#1b2640',
  color: '#94a3b8',
  fontWeight: 'bold',
  fontSize: '0.78rem',
  borderColor: 'rgba(255, 255, 255, 0.08)',
  letterSpacing: 0.5,
};

const cellSx = {
  py: 0.75,
  background: '#1b212f',
  borderColor: 'rgba(255,255,255,0.05)',
  color: '#b5b9bd',
  fontWeight: 500,
};

const TournamentPlayers = ({ torId }) => {
  const [players, setPlayers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const fetchPlayers = async () => {
      setIsLoading(true);
      try {
        const data = await getTournamentPlayers(torId);
        setPlayers(data);
      } catch (e) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPlayers();
  }, [torId]);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress sx={{ color: '#7c8cf8' }} />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error" sx={{ py: 3 }}>
        Error al cargar los jugadores.
      </Typography>
    );
  }

  if (!players.length) {
    return (
      <Typography sx={{ color: '#9aa5b4', py: 3 }}>
        No hay jugadores inscriptos en este torneo.
      </Typography>
    );
  }

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        borderRadius: 0,
        border: '1px solid rgba(255,255,255,0.08)',
        background: 'transparent',
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ ...headerSx, width: 70 }}>Pos.</TableCell>
            <TableCell sx={headerSx}>Apellido y Nombre</TableCell>
            <TableCell sx={{ ...headerSx, width: 100, textAlign: 'center' }}>Puntaje</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {players.map((p, idx) => (
            <TableRow key={idx} hover sx={{ '&:hover': { background: 'rgba(255,255,255,0.02) !important' } }}>
              <TableCell sx={{ ...cellSx, fontWeight: 'bold', textAlign: 'center', color: getPodiumColor(idx) }}>
                {p.jpt_posicion_final ?? idx + 1}
              </TableCell>
              <TableCell sx={cellSx}>{p.apellido_nombre}</TableCell>
              <TableCell sx={{ ...cellSx, textAlign: 'center', color: '#1e7185', fontWeight: 700 }}>
                {p.jpt_puntaje_final ?? '—'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TournamentPlayers;
